import { Burger, Group, AppShell, Image, Text, useMantineTheme } from '@mantine/core';

import { Departments } from './Departments';
import { LogoutButton } from './LogoutButton';

import config from '@/config';
import { useCurrentPath } from '@/hooks/useCurrentPath';

type Props = {
  opened: boolean;
  setOpened: (opened: boolean) => void;
};

const buildBreadcrumbs = (path: string) => {
  return path
    .replaceAll('prophet', 'bot')
    .replaceAll('pages', 'integrations')
    .slice(1)
    .split('/')
    .map((str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase())
    .join(' → ');
};

export const Header = ({ opened, setOpened }: Props) => {
  const theme = useMantineTheme();

  const path = useCurrentPath();

  return (
    <AppShell.Header h={70} p="md">
      <Group justify="space-between">
        <Burger
          hiddenFrom={'sm'}
          opened={opened}
          onClick={() => setOpened(!opened)}
          size="sm"
          color={theme.colors.gray[6]}
        />
        <Group>
          <LogoutButton />
          <Departments />
          <Text visibleFrom="sm" fw="bold" size="sm" opacity={0.9} fs="italic">
            {buildBreadcrumbs(path)}
          </Text>
        </Group>
        <Image visibleFrom="sm" src={config.brand.logo} alt="logo" h={31} w="auto" />
      </Group>
    </AppShell.Header>
  );
};
